import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { fetchAllVideos } from "../firebase/fireStoreServices";

export default function AllVideosSection() {
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const loadVideos = async () => {
      const videosData = await fetchAllVideos();
      setVideos(videosData);
    };
    loadVideos();
  }, []);

  const extractYouTubeId = (url) => {
    // Support for both 'youtu.be' and 'youtube.com/watch?v=' formats
    const shortUrlMatch = url.match(/youtu\.be\/([^?&]+)/);
    const longUrlMatch = url.match(/v=([^?&]+)/);
    return shortUrlMatch?.[1] || longUrlMatch?.[1] || "";
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 3 }}>
      <Divider>
        <Typography
          variant="h4"
          fontWeight="bold"
          color="secondary"
          sx={{ my: 4, textAlign: "center" }}
        >
          Latest YouTube Videos 🎥
        </Typography>
      </Divider>

      <Grid container spacing={3}>
        {videos.map((video) => {
          const videoId = extractYouTubeId(video.url);
          const isSelected = selectedVideoId === videoId;

          return (
            <Grid item xs={12} sm={6} md={4} key={video.id}>
              <Box>
                <Card
                  sx={{
                    boxShadow: 3,
                    borderRadius: 2,
                    transition: "transform 0.3s, box-shadow 0.3s",
                    "&:hover": {
                      transform: "scale(1.05)",
                      boxShadow: 15,
                    },
                  }}
                >
                  <CardActionArea onClick={() => setSelectedVideoId(videoId)}>
                    <CardMedia
                      component="img"
                      height="200"
                      image={video.thumbnail}
                      alt={video.title}
                      sx={{ objectFit: "cover", width: "100%" }}
                    />
                    <CardContent>
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        sx={{ textAlign: "center" }}
                      >
                        {video.title} <YouTubeIcon />
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>

                {/* Inline Video Display */}
                {isSelected && (
                  <Box
                    sx={{
                      mt: 2,
                      borderRadius: 2,
                      overflow: "hidden",
                      boxShadow: 3,
                      position: "relative",
                      paddingTop: "56.25%", // 16:9 aspect ratio
                    }}
                  >
                    <iframe
                      src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
                      title="YouTube Video"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        border: "0",
                      }}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </Box>
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
}
